import Model from '@/models/Model';

export default class ContractPeriod extends Model {
    get route () {
        return 'contract-periods';
    }

    static get className () {
        return 'ContractPeriod';
    }
}
